export const feedbackAnalyticsSelector = (state) => state.newJob.analytics.data;
export const isLoadingSelector = (state) => state.newJob.analytics.isLoading;
